module.exports = __webpack_public_path__ + "images/pro/img-pro-zoom-b955d489545cbf973718c5da6ad4f29b.jpg";